import React, { PureComponent } from 'react';

import { HELPER, JsBridge } from 'utils';

import {
  ConfirmPanel,
  ErrorBottomSheet,
  ModalConfirm,
  ModalInput,
  ModalInfo,
} from 'components';

import FormBuilder from 'containers/FormBuilder/FormBuilder.container';
import {
  ERROR_NOT_FOUND,
  ERROR_DEFAULT,
  ERROR_UNAUTHORIZED,
  ERROR_TRANSFER_DESTINATION_UNAVAILABLE,
  ERROR_INVALID_AMOUNT,
  ERROR_BILL_ALREADY_PAID,
  ERROR_BILL_ALREADY_EXPIRED,
  ERROR_BILLER_PAYMENT_NOT_FOUND,
  ERROR_INFO,
} from 'assets';
import {
  BILLER_PAGE,
  ITERATE_RETRY,
  CACHE_FROM_PAYMENT,
  CACHE_AMOUNT,
  CACHE_FROM_TNC,
} from 'constant/ConstVariable';
import { isEmpty, get, has } from 'lodash';

import config from './GenesisFormPage.page.config';
import text from './GenesisFormPage.page.translation';
import '../GeneralFormPage/GeneralFormPage.less';

class GenesisFormPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      biller: {},
      forms: {},
      billerPrefix: [],

      panelVisible: false,
      nameModalVisible: false,
      upgradeKycVisible: false,

      modalConfirmVisible: false,
      modalConfirmTitle: '',
      modalConfirmDesc: '',
      modalConfirmBtn: {},

      modalInfoVisible: false,

      bottomSheetErrorVisible: false,
      bottomSheetErrorData: {
        img: '',
        title: '',
        desc: '',
      },
      bottomSheetErrorBtn: {
        text: '',
        onClick: () => {},
      },
      bottomSheetErrorOnChange: () => {},

      iterateRetry: 0,
      payerName: '',
      checkedTnc: false,
      billerWithTnc: false,
    };
  }

  static getDerivedStateFromProps(prevProps) {
    if (!isEmpty(prevProps.biller)) {
      return {
        biller: prevProps.biller,
        forms: prevProps.formData,
        billerPrefix: prevProps.prefix,
      };
    }
    return null;
  }

  _getNewStateOnHashChange = val => {
    let result = {
      panelVisible: false,
      bottomSheetErrorVisible: false,
      modalConfirmVisible: false,

      nameModalVisible: false,
      upgradeKycVisible: false,
    };

    let getHash = '';
    const splitResult = val.newURL.split('#');
    if (splitResult.length > 1) {
      const [, hashValue] = splitResult;
      getHash = hashValue;
    }

    switch (getHash) {
      case 'confirmPanel':
        result.panelVisible = true;
        break;
      case 'nameModal':
      case 'errorLimitModal':
      case 'errorBalanceModal':
      case 'errorPanel':
      case 'upgradeKycPanel':
        result = '';
        break;
      default:
        break;
    }

    return result;
  };

  _trackPaymentOpen = () => {
    const {
      formValue: { selectedPrefix },
      trackEvent,
      location: {
        state: { error },
      },
    } = this.props;

    let reason = 'Amount not found (Open VA)';
    if (
      error === 'AMOUNT_NOT_FOUND' &&
      get(selectedPrefix, 'default_need_amount')
    ) {
      reason = 'Amount unfilled (Non Genesis prefix)';
    } else if (error === 'AMOUNT_AND_PAYER_INFO_NOT_FOUND') {
      reason =
        'Amount and payer info not found (Non genesis prefix and non KYC)';
    }

    trackEvent('Amount Input Page Extend', {
      Reasoning: reason,
    });
  };

  componentDidMount() {
    JsBridge.setDefaultBack();

    const componentParse = JSON.parse(
      get(this.state.forms, 'components') || '{}',
    );
    const lang = HELPER.getLang();
    sessionStorage.setItem(CACHE_FROM_PAYMENT, true);
    JsBridge.setTitle(
      get(
        componentParse,
        `${lang}.paymentTitle`,
        this.props.intl.formatMessage(text.genesis.title),
      ),
    );
    window.onhashchange = this._onHashChange;

    this._trackPaymentOpen();
  }

  predefineValue = () => {
    const cacheAmount = sessionStorage.getItem(CACHE_AMOUNT) || '';
    const fromCache = sessionStorage.getItem(CACHE_FROM_TNC) === 'true';

    if (fromCache) {
      this.props.updateFieldForm(
        'amount',
        HELPER.parseNumber(cacheAmount || 0),
      );

      sessionStorage.removeItem(CACHE_AMOUNT);
      sessionStorage.removeItem(CACHE_FROM_TNC);

      const newState = this._getNewStateOnHashChange({
        newURL: window.location.href,
      });

      if (newState) {
        this.setState(newState);
      }
    } else {
      this._trackPaymentOpen();
    }
  };

  _onHashChange = val => {
    const newState = this._getNewStateOnHashChange(val);
    if (newState) {
      this.setState(newState);
    }
  };

  _getPrefixIndex = value =>
    this.state.billerPrefix.findIndex(
      ({ va_prefix: prefix }) => prefix === value.substring(0, prefix.length),
    );

  _getCustomerNumber = () => {
    const { forms, biller } = this.state;
    const {
      formValue: { selectedPrefix, customerNumber },
    } = this.props;
    const formObj = JSON.parse(get(forms, 'components') || '{}');
    let custNumber = customerNumber;
    const selectedPrefixIndex = this._getPrefixIndex(customerNumber);

    const showPrefix = has(formObj, 'showPrefix')
      ? get(formObj, 'showPrefix')
      : 'no';

    const dontShowVA = showPrefix === 'no';
    const showVA = showPrefix === 'yes';
    const isPhoneNumber =
      get(formObj, 'components[0].component') === 'PhoneNumberInput';

    const validationPrefix = has(formObj, 'validationPrefix')
      ? get(formObj, 'validationPrefix')
      : 'dynamic';
    const noValidate = validationPrefix === 'no';

    if (
      (selectedPrefixIndex === -1 || noValidate) &&
      showVA &&
      biller.biller_type === 2
    ) {
      if (isPhoneNumber) {
        const phoneNumber = custNumber.match(/^\(?(628)\)?\d/)
          ? custNumber.slice(3)
          : custNumber.slice(2);

        return {
          custNumber:
            get(this.state, 'billerPrefix[0].va_prefix') + phoneNumber,
          prefix: selectedPrefix,
        };
      }
      return {
        custNumber: get(this.state, 'billerPrefix[0].va_prefix') + custNumber,
        prefix: selectedPrefix,
      };
    }

    if (selectedPrefixIndex !== -1 && dontShowVA) {
      custNumber = customerNumber.slice(
        get(
          this.state,
          `billerPrefix[${selectedPrefixIndex}].va_prefix.length`,
        ),
      );
      if (isPhoneNumber) {
        custNumber = `08${custNumber}`;
      }
    }

    return {
      custNumber,
      prefix: selectedPrefix,
    };
  };

  _handlePressBack = () => {
    this.props.history.goBack();
  };

  _handleBacktoList = errorCheckout => () => {
    // Pas Back to Before Page
    const fromBiller = this.isFromBiller();
    if (fromBiller && errorCheckout) this.props.history.go(-3);
    else if (fromBiller) this.props.history.go(-4);
    else {
      JsBridge.close();
    }
  };

  _updateHashUrl = hash => {
    window.location.assign(hash);
  };

  _replaceHashUrl = hash => {
    window.location.replace(hash);
  };

  _retryRequest = errorCheckout => {
    this.setState(
      prevState => ({ iterateRetry: prevState.iterateRetry - 1 }),
      () => {
        if (errorCheckout) {
          this._requestCheckout();
        } else {
          this._requestPay();
        }
      },
    );
  };

  isFromBiller = () => sessionStorage.getItem(BILLER_PAGE);

  _onCheckoutError = errorCheckout => err => {
    const {
      intl: { formatMessage },
    } = this.props;

    const title = get(err, 'response.data.message.title', '');
    this.props.setLoading(false);
    // Custom Error Message
    const defaultMessage = {
      title: formatMessage(text.errorMessage.default.title),
      description: formatMessage(text.errorMessage.default.desc),
      icon: ERROR_DEFAULT,
    };

    switch (title) {
      case 'TRANSFER_DESTINATION_UNAVAILABLE':
        if (this.state.iterateRetry === 0) {
          this._showErrorPanel({
            title: formatMessage(
              text.errorMessage.transferDestinationUnavailable.title,
            ),
            description: formatMessage(
              text.errorMessage.transferDestinationUnavailable.desc,
            ),
            icon: ERROR_TRANSFER_DESTINATION_UNAVAILABLE,
            btn: {
              text: this.props.intl.formatMessage(text.buttonClose),
              onClick: this._handlePressBack,
            },
          });
        } else {
          this._retryRequest(errorCheckout);
        }
        break;
      case 'INVALID_AMOUNT':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.invalidAmount.title),
          description: formatMessage(text.errorMessage.invalidAmount.desc),
          icon: ERROR_INVALID_AMOUNT,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_ALREADY_PAID':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billAlreadyPaid.title),
          description: formatMessage(text.errorMessage.billAlreadyPaid.desc),
          icon: ERROR_BILL_ALREADY_PAID,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_ALREADY_EXPIRED':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billAlreadyExpired.title),
          description: formatMessage(text.errorMessage.billAlreadyExpired.desc),
          icon: ERROR_BILL_ALREADY_EXPIRED,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_PAYMENT_NOT_FOUND':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billerPaymentNotFound.title),
          description: formatMessage(
            text.errorMessage.billerPaymentNotFound.desc,
          ),
          icon: ERROR_BILLER_PAYMENT_NOT_FOUND,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'CHANNEL_UNABLE_TO_PROCESS':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.channelUnableToProcess.title),
          description: formatMessage(
            text.errorMessage.channelUnableToProcess.desc,
          ),
          icon: ERROR_INFO,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'TRANSFER_DESTINATION_NOT_FOUND':
        if (this.state.iterateRetry === 0) {
          this.setState({ nameModalVisible: false });
          this._showErrorPanel({
            title: formatMessage(text.errorMessage.accountNotFound.title),
            description: formatMessage(text.errorMessage.accountNotFound.desc),
            icon: ERROR_NOT_FOUND,
            btn: {
              text: this.props.intl.formatMessage(text.buttonClose),
              onClick: this._handlePressBack,
            },
          });
        } else {
          this._retryRequest(errorCheckout);
        }
        break;

      case 'PAYER_INFO_NOT_FOUND':
        this._showNameModal(err);
        break;
      case 'FORBIDDEN':
        this._handlePressBack();
        break;
      case 'ORDER_BILLER_INACTIVE':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billerInactive.title),
          description: formatMessage(text.errorMessage.billerInactive.desc),
          icon: ERROR_UNAUTHORIZED,
          btn: {
            text: formatMessage(text.buttonBack).toUpperCase(),
            onClick: this._handleBacktoList(errorCheckout),
          },
        });
        break;
      case 'INTEGRATION_ERROR':
      case 'DANA_SYSTEM_ERROR':
      case 'TRANSFER_NETWORK_ERROR':
      case 'BILLER_CODE_INVALID':
      case 'DANA_RISK_REJECT':
      default:
        this._showErrorPanel(defaultMessage);
        break;
    }
  };

  _showNameModal = err => {
    const defaultName = this._getDefaultName(err);
    this.setState(
      {
        nameModalVisible: true,
        nameModalDefaultValue: defaultName,
      },
      this._updateHashUrl('#nameModal'),
    );
  };

  _isNicknameValid = nickname => {
    const regex = /^[a-zA-Z ]*[a-zA-Z]+[a-zA-Z ]*$/;
    return regex.test(nickname);
  };

  _getDefaultName = err => {
    let result = '';
    const nickname = get(
      err,
      'response.data.message.additional_info.payer_nickname',
      '',
    );

    if (nickname) {
      const isValid = this._isNicknameValid(nickname);

      if (isValid) {
        result = nickname;
      }
    }

    return result;
  };

  _showErrorPanel = errorMessage => {
    // Build Data Panel
    // Save State
    this.setState(
      {
        bottomSheetErrorVisible: true,
        bottomSheetErrorData: {
          img: errorMessage.icon,
          title: errorMessage.title,
          desc: errorMessage.description,
        },
        bottomSheetErrorBtn: errorMessage.btn || {
          text: this.props.intl.formatMessage(text.buttonClose),
          onClick: this._handlePressBack,
        },
        bottomSheetErrorOnChange: this._handlePressBack,
        nameModalVisible: false,
      },
      this._updateHashUrl('#errorPanel'),
    );
  };

  _onChangePanel = isOpen => {
    const { history } = this.props;
    if (isOpen) {
      this.setState(
        {
          panelVisible: true,
        },
        this._replaceHashUrl('#confirmPanel'),
      );
    } else {
      history.goBack();
    }
  };

  _requestPay = () => {
    const { checkout, biller, requestPay, userAgreements } = this.props;
    const salesOrderId = get(checkout, 'sales_order_id', '');
    this.props.setLoading(true);

    if (biller.tnc && userAgreements.length <= 0) {
      this.agreeTnc(() => {
        requestPay(salesOrderId)
          .then(this._nextRequestPay)
          .catch(this._onCheckoutError(false));
      });
    } else if (biller.tnc && userAgreements.length > 0) {
      if (
        get(biller, 'tnc.latest_version_name', '') ===
        get(userAgreements, '0.tnc_version_name', null)
      ) {
        requestPay(salesOrderId)
          .then(this._nextRequestPay)
          .catch(this._onCheckoutError(false));
      } else {
        this.agreeTnc(() => {
          requestPay(salesOrderId)
            .then(this._nextRequestPay)
            .catch(this._onCheckoutError(false));
        });
      }
    } else {
      requestPay(salesOrderId)
        .then(this._nextRequestPay)
        .catch(this._onCheckoutError(false));
    }
  };

  agreeTnc = callback => {
    const { biller, signatureAgreementTNC } = this.props;
    const tncID = get(biller, 'tnc.public_id', '');
    const tncVersion = get(biller, 'tnc.latest_version_name', '');
    const date = new Date();
    const buildFingerprint = {
      userAgent: navigator.userAgent,
      dateTime: date.getTime(),
      timeZone: date.getTimezoneOffset(),
      lang: HELPER.getLang(),
    };
    const createSignature = btoa(JSON.stringify(buildFingerprint));
    const params = {
      signature: createSignature,
      version: tncVersion,
    };

    signatureAgreementTNC(tncID, params)
      .then(() => {
        callback();
      })
      .catch(this._onCheckoutError(false));
  };

  _panelConfirm = () => {
    this.setState({ iterateRetry: ITERATE_RETRY }, this._requestPay);
  };

  _nextRequestPay = result => {
    this._handlePressBack();
    this._trackOrder('Create Order');

    if (window.IS_IN_SKYWALKER) {
      JsBridge.call('callSubApp', {
        url: result.dana_cashier_url,
      });
    } else {
      window.location.assign(result.dana_cashier_url);
    }
    this.props.setLoading(false);
  };

  _renderBtnText = (formData, lang) => {
    if (isEmpty(formData) || formData.components === '') {
      return 'NEXT';
    }
    const componentParse = JSON.parse(formData.components);
    return get(componentParse, `${lang}.btnText`, 'NEXT').toUpperCase();
  };

  _trackOrder = eventName => {
    const {
      formValue: { selectedPrefix },
      trackEvent,
      intl: { locale },
      reduxFormValue: { amount },
    } = this.props;
    const { forms } = this.state;

    const params = {
      'VA Prefix': get(selectedPrefix, 'va_prefix'),
      'Biller Type': get(selectedPrefix, 'default_need_amount')
        ? 'Open VA'
        : 'Closed VA',
    };

    // Check Empty Form Data & String
    if (!isEmpty(forms) && forms.components !== '') {
      // Parsing The Component
      const componentParse = JSON.parse(get(forms, 'components') || '{}');
      const topUpComponent = componentParse.components.find(
        component => component.component === 'AmountInputPredefined',
      );
      const topUpConfig = get(topUpComponent, `config.${locale}.general`, {});

      Object.values(topUpConfig).forEach(value => {
        if (parseInt(value, 10) === amount) {
          params['Package Denom'] = amount;
        }
      });
    }
    trackEvent(eventName, params);
  };

  _checkoutSuccess = () => {
    this._trackOrder('Checkout Open');
    this._updateHashUrl('#confirmPanel');
  };

  _requestCheckout = () => {
    const { biller, payerName } = this.state;
    const { userAgreements, additionalInfo } = this.props;
    const customerNumber = get(this.props, 'formValue.customer_number').replace(
      /\s/g,
      '',
    );

    const amount = get(this.props, 'reduxFormValue.amount').toString();
    const payload = {
      biller_id: biller.id,
      customer_number: customerNumber,
      transaction_amount: amount,
      additional_info: { ...additionalInfo },
    };

    if (payerName) {
      payload.payer_name = payerName;
    }

    this.props
      .createCheckout(payload)
      .then(success => {
        if (success) {
          if (biller.tnc && userAgreements.length <= 0) {
            this.setState(
              {
                checkedTnc: false,
                billerWithTnc: true,
                panelVisible: true,
              },
              this._checkoutSuccess,
            );
          } else if (biller.tnc && userAgreements.length > 0) {
            if (
              get(biller, 'tnc.latest_version_name', '') ===
              get(userAgreements, '0.tnc_version_name', null)
            ) {
              this.setState(
                {
                  checkedTnc: true,
                  billerWithTnc: true,
                  panelVisible: true,
                },
                this._checkoutSuccess,
              );
            } else {
              this.setState({
                checkedTnc: false,
                billerWithTnc: true,
                modalInfoVisible: true,
              });
            }
          } else {
            this.setState(
              {
                checkedTnc: false,
                billerWithTnc: false,
                panelVisible: true,
              },
              this._checkoutSuccess,
            );
          }
        }
      })
      .catch(this._onCheckoutError(true));
  };

  _closeInfo = () => {
    this.setState(
      {
        modalInfoVisible: false,
        panelVisible: true,
      },
      this._checkoutSuccess,
    );
  };

  _onSubmitInputSenderName = payerName => {
    this.setState(
      { iterateRetry: ITERATE_RETRY, payerName },
      this._requestCheckout,
    );
  };

  _onCheckTnc = () => {
    this.setState(prevState => ({
      checkedTnc: !prevState.checkedTnc,
    }));
  };

  _renderFormBuilder = (formData, lang) => {
    const {
      intl: { formatMessage },
      intl,
    } = this.props;

    const messageEmpty = (
      <center>
        <br />
        <br />
        <h2>{formatMessage(text.emptyform)}</h2>
        <p>{formatMessage(text.emptyFormDesc)}</p>
      </center>
    );
    // Check Empty Form Data & String
    if (isEmpty(formData) || formData.components === '') {
      return messageEmpty;
    }
    // Parsing The Component
    const componentParse = JSON.parse(get(formData, 'components') || '{}');

    const vaPrefix = this.state.billerPrefix.map(biller => biller.va_prefix);
    // Check if component length if empty
    if (this.state.isGenesis) {
      componentParse.components.splice(1, 1);
    }

    if (componentParse.components.length <= 0) {
      return messageEmpty;
    }

    const paymentComponents =
      get(componentParse, 'paymentComponents.length', '0') > 0
        ? componentParse.paymentComponents
        : [componentParse.components[1]];

    return (
      <FormBuilder
        isGenesis
        formData={formData}
        lang={lang}
        formObject={paymentComponents}
        onSubmit={this._requestCheckout}
        billerData={this.state.biller}
        vaPrefix={vaPrefix}
        intl={intl}
        history={this.props.history}
        valueChanged={() => {}}
      />
    );
  };

  render() {
    const {
      forms,

      nameModalVisible,
      nameModalDefaultValue,

      modalConfirmVisible,
      modalConfirmTitle,
      modalConfirmDesc,
      modalConfirmBtn,

      modalInfoVisible,

      bottomSheetErrorVisible,
      bottomSheetErrorData,
      bottomSheetErrorBtn,
      bottomSheetErrorOnChange,
    } = this.state;
    const {
      deviceHeight,

      intl: { formatMessage },

      biller,
      isLoading,
    } = this.props;

    const customerNumber = this._getCustomerNumber();

    return (
      <div className="form-wrapper">
        <div
          className="biller-form"
          style={{
            minHeight: `${deviceHeight}px`,
            height: `${deviceHeight}px`,
          }}
        >
          <div className="biller-section-genesis">
            <div className="biller-icon">
              <img src={biller.icon_abs_url} alt="biller-icon" />
            </div>
            <div className="biller-text">
              <p className="account-number">
                {HELPER.formatNumber(get(customerNumber, 'custNumber', ''))}
              </p>
              <p className="biller-name">{`${get(
                biller,
                'service.name',
              )} - ${get(biller, 'name')}`}</p>
            </div>
          </div>
          {this._renderFormBuilder(forms, HELPER.getLang())}

          <ConfirmPanel
            {...this.props}
            customerNumber={this._getCustomerNumber()}
            visible={this.state.panelVisible}
            nameModalVisible={this.state.nameModalVisible}
            onChangePanel={this._onChangePanel}
            onCloseConfirmPanel={this._handlePressBack}
            onConfirm={this._panelConfirm}
            formValue={this.props.reduxFormValue}
            billerWithTnc={this.state.billerWithTnc}
            checkedTnc={this.state.checkedTnc}
            onCheckTnc={this._onCheckTnc}
          />

          <ModalInfo
            visible={modalInfoVisible}
            title={formatMessage(text.tnc.title)}
            desc={formatMessage(text.tnc.desc)}
            btn={formatMessage(text.tnc.btn)}
            onClose={this._closeInfo}
            icon={ERROR_INFO}
          />

          <ModalConfirm
            visible={modalConfirmVisible}
            title={modalConfirmTitle}
            desc={modalConfirmDesc}
            btn={modalConfirmBtn}
            onClose={this._handlePressBack}
          />

          <ModalInput
            visible={!isLoading && nameModalVisible}
            onClose={this._handlePressBack}
            onClickSubmit={this._onSubmitInputSenderName}
            title={formatMessage(text.senderNameTitle)}
            placeholder={formatMessage(text.senderNamePlaceholder)}
            btnLabel={formatMessage(text.senderNameAdd)}
            defaultValue={nameModalDefaultValue}
          />

          <ErrorBottomSheet
            visible={bottomSheetErrorVisible}
            btn={bottomSheetErrorBtn}
            error={bottomSheetErrorData}
            intl={this.props.intl}
            onChange={bottomSheetErrorOnChange}
          />
        </div>
      </div>
    );
  }
}

GenesisFormPage.propTypes = config.propTypes;
GenesisFormPage.displayName = config.displayName;
GenesisFormPage.defaultProps = config.defaultProps;

export default GenesisFormPage;
